import api from "../../../utils/api";
import {
  PAYROLL_HOURS_REVIEW_ENDPOINT,
  type PayrollHoursReview,
  type PayrollHoursReviewCost,
  type PayrollHoursReviewRow,
} from "@torre/work-hours";

// ---------------------------------------------------------------------------
// Revisión de horas por colaborador (#1346) — `GET /workHoursPayrollReview`.
//
// Alimenta la tabla de «Autorización de incidencias». Mismo contrato sin sobre
// que las entradas de tiempo. El ALCANCE lo decide el servidor (dueños y tech
// leads: todo el equipo; líder de squad: su gente; el resto: lo suyo) y también
// el DINERO: `cost` solo llega a los dueños. Esta capa no calcula nada.
// ---------------------------------------------------------------------------

export type HoursReviewScope = "all" | "squads" | "own";

/** Fila de la tabla: la del núcleo + si es de quien consulta. */
export interface HoursReviewRow extends PayrollHoursReviewRow {
  own: boolean;
}

export interface HoursReviewResponse {
  from: string;
  to: string;
  scope: HoursReviewScope;
  /** ¿El servidor mandó importes? Solo a los dueños. */
  canSeeAmounts: boolean;
  rows: HoursReviewRow[];
  totals: PayrollHoursReview["totals"];
  rule: {
    justified: string;
    approvalThresholdMinutes: number;
    /** Hasta qué día se cuenta el esperado (se corta en hoy). */
    expectedTo: string;
    businessDays: number | null;
    today: string | null;
  };
  /** La lectura llegó incompleta: las horas pueden venir de menos. */
  truncated: boolean;
  /** SOLO dueños: pérdida / ganancia en dinero por fila y por moneda. */
  cost?: PayrollHoursReviewCost;
}

export async function fetchHoursReview(params: { from: string; to: string }): Promise<HoursReviewResponse> {
  const res = await api.get(PAYROLL_HOURS_REVIEW_ENDPOINT, { params });
  return res?.data as HoursReviewResponse;
}
